<template>

	<div class="inset-0 fixed bg-black bg-opacity-90 z-[101] flex items-center justify-center h-screen" v-if="selected" @click.self="$emit('close')">

		<div class="p-1/2 pt-2 relative aspect-[992/667] max-h-screen">
			<img class="border border-white border-solid object-contain
			" :src="banners[brouseIndex]" @click="brouseIndex++" alt="">
			<img @click="$emit('close')" class="w-1.5 h-1.5 absolute top-1 right-1 cursor-pointer" src="/svg/x.svg" alt="Close Carousel">
			<div class="nav text-navy flex justify-center top-[-20px] space-x-1/2">
				<svg class="w-1.5 h-1.5 cursor-pointer" @click="brouseIndex--" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<circle cx="12" cy="12" r="10" class="fill-current" stroke="#fff" stroke-width="2"/>
					<polygon transform="translate(12, 12) scale(0.8) rotate(180) translate(-8, -7) " fill="white" points="16.32 7 11.5 0 6.5 0 10 5 0 5 0 9 10 9 6.5 14 11.5 14"></polygon>

				</svg>
				<svg class="w-1.5 h-1.5 cursor-pointer" @click="brouseIndex++" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<circle cx="12" cy="12" r="10" class="fill-current" stroke="#fff" stroke-width="2"/>
					<polygon transform="translate(12, 12) scale(0.8) translate(-8, -7)" fill="white" points="16.32 7 11.5 0 6.5 0 10 5 0 5 0 9 10 9 6.5 14 11.5 14"></polygon>
				</svg>
			</div>
		</div>
	</div>

</template>

<script>

	export default {
		props:['banners', 'selected', 'index'],
		data() {
			return {
				brouseIndex: 0
			}
		},
		watch: {
			selected(){
				this.brouseIndex = this.index
			},
			brouseIndex() {
				if (this.brouseIndex > this.banners.length-1){
					this.brouseIndex = 0
				}
				if (this.brouseIndex == -1){
					this.brouseIndex = this.banners.length-1
				}
			}
		},


	}
</script>

<style lang='less'>

@import '../../../../public/bower_components/3l/3L/3L.less';
@import '../../less/variables';
@import '../../less/helpers';

</style>


